import styled from 'styled-components';
import { colors, rgba } from '../../../style';
import { actionColor } from '../../../style/theme-helpers';
import { ButtonProps } from '../../button/button';
import Icon from '../../icon';

const StyledAppSwitcherButton = styled.button<ButtonProps>`
  height: 100%;
  width: 80px;
  background-color: ${props => props.theme.mainColor || actionColor(props)};
  display: inline-flex;
  border: 3px solid transparent;
  transition: 0.2s;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  &:hover:not([disabled]) {
    background-color: ${props => rgba(props.theme.mainColor || actionColor(props), 0.8)};
  }

  &:focus-visible:not([disabled]) {
    border: 3px solid ${actionColor};
  }

  &:active,
  &.active {
    background-color: ${actionColor};
  }

  &[disabled] {
    cursor: not-allowed;
    background-color: ${colors.gray400};
    color: ${colors.gray600};
  }
`;

const AppSwitcherButton = ({ disabled, ...rest }: ButtonProps) => (
  <StyledAppSwitcherButton aria-label={'open navigation menu'} disabled={disabled} className={'hidden-xs'} {...rest}>
    <Icon name={'APPS'} size={'2xxl'} variant={'white'} />
  </StyledAppSwitcherButton>
);

AppSwitcherButton.displayName = 'AppSwitchButton';
export default AppSwitcherButton;
